import { useState, useEffect } from 'react';

// Timing (all in milliseconds)
const TYPING_SPEED_MS = 80;
const BACKSPACE_SPEED_MS = 60;
const PAUSE_AFTER_TYPO_MS = 600;
const PAUSE_BEFORE_CORRECT_MS = 200;
const INITIAL_DELAY_MS = 300;
const CURSOR_HIDE_DELAY_MS = 400;

const useTypingAnimation = (typo, correct) => {
  const [displayName, setDisplayName] = useState("");
  const [showCursor, setShowCursor] = useState(true);

  useEffect(() => {
    // Skip animation if user has motion sensitivity enabled
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion) {
      setDisplayName(correct);
      setShowCursor(false);
      return;
    }

    const timers = [];
    let currentText = "";
    let charIndex = 0;

    // Type the typo
    const typeTypo = () => {
      if (charIndex < typo.length) {
        currentText += typo[charIndex];
        setDisplayName(currentText);
        charIndex++;
        timers.push(setTimeout(typeTypo, TYPING_SPEED_MS));
      } else {
        timers.push(setTimeout(startBackspace, PAUSE_AFTER_TYPO_MS));
      }
    };

    // Backspace to "ta"
    const startBackspace = () => {
      const backspace = () => {
        if (currentText.length > 2) {
          currentText = currentText.slice(0, -1);
          setDisplayName(currentText);
          timers.push(setTimeout(backspace, BACKSPACE_SPEED_MS));
        } else {
          timers.push(setTimeout(typeCorrect, PAUSE_BEFORE_CORRECT_MS));
        }
      };
      backspace();
    };

    // Type the correct name
    const typeCorrect = () => {
      charIndex = currentText.length;

      const typeNext = () => {
        if (charIndex < correct.length) {
          currentText = correct.slice(0, charIndex + 1);
          setDisplayName(currentText);
          charIndex++;
          timers.push(setTimeout(typeNext, TYPING_SPEED_MS));
        } else {
          timers.push(setTimeout(() => setShowCursor(false), CURSOR_HIDE_DELAY_MS));
        }
      };
      typeNext();
    };

    timers.push(setTimeout(typeTypo, INITIAL_DELAY_MS));

    // Cleanup timers on unmount
    return () => timers.forEach(timer => clearTimeout(timer));
  }, [typo, correct]);

  return { displayName, showCursor };
};

export default useTypingAnimation;
